export const offers = [
  {
    id: "jimny",
    name: "Maruti Jimny",
    discount: 90000,
    pic: require("../assets/nexa/jimny.png"),
  },
];
